import React from 'react';

import pictoReglage from "../../assets/images/picto-reglage.svg";

import pictoCarto from "../../assets/images/carto.jpg";
import reliefCouleur from "../../assets/images/relief-couleur.jpg";
import reliefNB from "../../assets/images/relief-nb.jpg";
import pictoIGN from "../../assets/images/ign.jpg";


export const SelectBackground = ({backgroundActif, showBaseLayer}) => {
    return (
        <div className="outils-carte">
            <div className="choix-fond">
                <div className="choix-fond-titre d-flex pb-3">
                    <div className="col-4">
                        <div className="dotted-pattern w-100"></div>
                    </div>
                    <span className="fs-7 ms-1 d-flex flex-column justify-content-end lh-xs pb-1 ps-2">
                        <strong>Fond</strong>
                        <span>de plan</span>
                    </span>
                </div>
                <ul className="list-unstyled d-flex flex-column align-items-center m-0">

                    <li className="d-flex mb-3">
                        <a href="#!" onClick={()=> showBaseLayer('Plan IGN') } data-bs-toggle="tooltip" data-bs-placement="left" title="Plan IGN">
                            <img className="w-100 h-100 object-fit-cover" src={pictoIGN} />
                        </a>
                    </li>
                    <li className="d-flex mb-3">
                        <a href="#!" onClick={()=> showBaseLayer('Relief ombré N&B') } data-bs-toggle="tooltip" data-bs-placement="left" title="Relief ombré N&B">
                            <img className="w-100 h-100 object-fit-cover" src={reliefNB} />
                        </a>
                    </li>
                    <li className="d-flex mb-3">
                        <a href="#!" onClick={()=> showBaseLayer('Relief ombré couleur') } data-bs-toggle="tooltip" data-bs-placement="left" title="Relief ombré couleur">
                            <img className="w-100 h-100 object-fit-cover" src={reliefCouleur} />
                        </a>
                    </li>
                    <li className="d-flex mb-3">
                        <a href="#!" onClick={()=> showBaseLayer('Photos aériennes') } data-bs-toggle="tooltip" data-bs-placement="left" title="Photos aériennes">
                            <img className="w-100 h-100 object-fit-cover" src={pictoCarto}/>
                        </a>
                    </li>
                </ul>
                <div className="actif smooth">
                    <img className="regl position-absolute z-2 start-50 top-50" src={pictoReglage} />
                    {(() => {
                        if(backgroundActif == 'Photos aériennes') return <img className="obj w-100 h-100 object-fit-cover smooth" src={pictoCarto} />
                        else if(backgroundActif == 'Relief ombré couleur') return <img className="obj w-100 h-100 object-fit-cover smooth" src={reliefCouleur} />
                        else if(backgroundActif == 'Relief ombré N&B') return <img className="obj w-100 h-100 object-fit-cover smooth" src={reliefNB} />
                        else if(backgroundActif == 'Plan IGN') return <img className="obj w-100 h-100 object-fit-cover smooth" src={pictoIGN} />
                    })()}
                </div>
            </div>
        </div>
    );
}